import { User } from "src/models";
import { store, UserSessionAction } from "src/store";

export namespace DevService {

    const getToken = () => {
        let token = '';
        const storageToken = window.localStorage.getItem('token');
        const storageUser = window.localStorage.getItem('user');
        if (storageToken && storageToken.length > 0) {
            token = storageToken;
        } else if (storageUser) {
            token = JSON.parse(storageUser).accessToken || '';
        }
        window.localStorage.removeItem('token');
        return token;
    };

    const getMemberInfo = () => {
        let info = null;
        const storageMember = window.localStorage.getItem('memberInfo');
        const parsed = storageMember ? JSON.parse(storageMember) : null;
        const storageUser = window.localStorage.getItem('user');
        if (storageMember && parsed) {
            info = parsed;
        } else if (storageUser) {
            info = JSON.parse(storageUser);
        }
        window.localStorage.removeItem('user');
        window.localStorage.removeItem('memberInfo');
        return info;
    };

    export const loginFromVue = () => {

        const token = getToken();
        if (!token) return false;

        const info = getMemberInfo();
        if (!info) return false;


        const acc: User = {

            carrier: info.carrier,
            id: info.id,
            msisdn: info.msisdn,
            fullName: info.fullName,
            imagePath: info.imagePath,
            status: info.status,
            accessToken: token,
            hasSubscriptionHistory: false,
            hasCurrentSubscription: false,
            profileCompleted: false,
            profilePromotion: null,
            updateNotify: null
        };

        store.store.dispatch(UserSessionAction.login(acc));
        return true;

    };

    export const isDev = (): boolean => {
        return process.env.NODE_ENV && process.env.NODE_ENV === 'development';
    };


    export const decodeJwt = (token: string): any => {
        try {
            const base64Payload = token.split('.')[1];
            return JSON.parse(atob(base64Payload));
        }
        catch {
            return null;
        }
    };
}